var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      "label-width": "80px",
      model: _vm.form,
      "label-position": "left"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：以下所有内容必填")]), _c("el-form-item", {
    attrs: {
      label: "服务器列表",
      "label-width": "100px"
    }
  }, [_c("server-list", {
    attrs: {
      readCacheType: 1,
      multiple: false,
      type: 1
    },
    model: {
      value: _vm.form.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "server_id", $$v);
      },
      expression: "form.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色ID",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.playerIDString,
      callback: function callback($$v) {
        _vm.playerIDString = $$v;
      },
      expression: "playerIDString"
    }
  }), _c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：玩家ID之间,请用（英文逗号）隔开。必填")])], 1), _c("el-form-item", {
    attrs: {
      label: "禁言原因",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.ban_reason,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ban_reason", $$v);
      },
      expression: "form.ban_reason"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "禁言时间/秒",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "input",
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.preserBtn();
      }
    }
  }, [_vm._v("保 存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };